import { createContext, useContext } from 'react';
import type { ColumnInput, CreateExportJobMutationResult, ExportFormat, Forms } from '@/types/export';

export type CreateExportJobVariables<TForm> = {
  export: {
    format: ExportFormat;
    form: TForm;
    columns: ColumnInput[];
    filter: string | null;
  };
};

export type ExportHooks<TForm> = {
  createExportJob: (
    variables: CreateExportJobVariables<TForm>,
  ) => Promise<CreateExportJobMutationResult>;
};

export const ExportContext = createContext<ExportHooks<Forms>>({
  createExportJob: async () => null,
});

export const useExportContext = <TForm extends Forms>(): ExportHooks<TForm> =>
  useContext(ExportContext) as ExportHooks<TForm>;
